<template>
  <div class="home" style="height: 100%">
    <v-container style="height: 100%">
      <v-row align="center" style="height: 100%">
        <v-col cols="12" md="6">
          <v-img src="../assets/simulator_iPhoneX.png"/>
        </v-col>
        <v-col md="6" cols="12">
          <Title/>
          <v-row>
            <v-col md="4" lg="3" cols="12" align="center">
              <circle-text text="120万DL" color="#5491D2" style="max-width: 180px"/>
            </v-col>
            <v-col md="4" lg="3" cols="12" align="center">
              <circle-text text="多機能" color="#55B572" style="max-width: 180px"/>
            </v-col>
            <v-col md="4" lg="3" cols="12" align="center">
              <circle-text text="登録不要" color="#C74C72" style="max-width: 180px"/>
            </v-col>
          </v-row>
        </v-col>
          <v-col cols="12" class="text-center font-weight-bold title">
            お問い合わせは<a href="https://twitter.com/ToDoForUniv">Twitter</a>もしくはメールアドレスtodoforstudents[at]gmail.com（[at]を@に変換してください）まで！
          </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Title from '../components/Title'
import CircleText from '../components/CircleText'

export default {
  name: 'Home',
  components: { CircleText, Title }
}
</script>
